import React from 'react';

export default ({ headerShouldShowCTA, updateUI, analytics }) =>
  (headerShouldShowCTA && (
    <div className="c-header__cta c-header__cta--visible">
      <button
        type="button"
        className="bt--primary"
        onClick={() => {
          window.scroll(0, 0);
          analytics.track('header-search-cta-clicked');
          updateUI({
            headerShouldShowCTA: false,
            animateSearchForm: true
          });
        }}
      >
        <span>Find parking</span>
      </button>
    </div>
  )) ||
  null;
